import {getFormattedWebsitePath} from "@/utilities";

export default ({blog = {}} = {}) => {

    const {meta_title = '', meta_description = '', image = ''} = blog || {}

    const {getRobotsMeta, getLinks} = useSeoMeta()

    return {
        meta: [
            {
                name: 'description',
                content: meta_description
            },
            //   // Twitter
            {name: 'twitter:card', content: 'article.group'},
            {
                name: 'twitter:title',
                content: meta_title
            },
            {
                name: 'twitter:description',
                content: meta_description
            },
            {
                name: 'twitter:image',
                content: image
            },
            {
                property: 'og:title',
                content: meta_title
            },
            {
                property: 'og:description',
                content: meta_description
            },
            {
                property: 'og:image',
                itemprop: 'image',
                content: image
            },
            {
                property: 'og:image:alt',
                content: image
            },
            ...getRobotsMeta(),
        ],
        link: () => [...(getLinks() || [])]
    }
}
